import { Box, Link, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { branchlist } from '../../feature/api/Complaint'

const Branches = () => {
    const dispatch = useDispatch()
    const branches = useSelector(state => state.complaint.branches)

    useEffect(()=>{
        dispatch(branchlist())
    },[])
  return (
    <Box bgcolor={"#000"}>
        <TableContainer sx={{width:'100%',border:'1px solid #dc7200'}}>
        <Table sx={{  minWidth:650}} aria-label="simple table">
            <TableHead>
            <TableRow>
                <TableCell sx={{fontWeight:900,color:'#dc7200',fontSize:'16px',borderLeft:'1px solid #fff'}}>کد شعبه</TableCell>
                <TableCell sx={{fontWeight:900,color:'#dc7200',fontSize:'16px',borderLeft:'1px solid #fff'}}>استان</TableCell>
                <TableCell sx={{fontWeight:900,color:'#dc7200',fontSize:'16px',borderLeft:'1px solid #fff'}}>شهر</TableCell>
                <TableCell sx={{fontWeight:900,color:'#dc7200',fontSize:'16px',borderLeft:'1px solid #fff'}}>نام شعبه</TableCell>
                <TableCell sx={{fontWeight:900,color:'#dc7200',fontSize:'16px',borderLeft:'1px solid #fff'}}>صاحب امتیاز</TableCell>
                <TableCell sx={{fontWeight:900,color:'#dc7200',fontSize:'16px',borderLeft:'1px solid #fff'}}> ساعات کاری </TableCell>
                <TableCell sx={{fontWeight:900,color:'#dc7200',fontSize:'16px',borderLeft:'1px solid #fff'}}>  آدرس شعبه </TableCell>
                <TableCell sx={{fontWeight:900,color:'#dc7200',fontSize:'16px',borderLeft:'1px solid #fff'}}>  </TableCell>
                <TableCell sx={{fontWeight:900,color:'#dc7200',fontSize:'16px',borderLeft:'1px solid #fff'}}>  </TableCell>
                <TableCell sx={{fontWeight:900,color:'#dc7200',fontSize:'16px',borderLeft:'1px solid #fff'}}>  </TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {branches?.map((row) => (
                <TableRow
                key={row.branch}
              
                sx={{ '&:hover':{bgcolor:'#dc7200'} }}
                >
                    <TableCell sx={{color:'#fff'}}>
                        {row.branch}
                    </TableCell>
                    <TableCell  sx={{color:'#fff',borderLeft:'1px solid #fff'}}>{row.province}</TableCell>
                    <TableCell  sx={{color:'#fff',borderLeft:'1px solid #fff'}}>{row.city}</TableCell>
                    <TableCell  sx={{color:'#fff',borderLeft:'1px solid #fff'}}>{row.location}</TableCell>
                    <TableCell  sx={{color:'#fff',borderLeft:'1px solid #fff'}}>{row.holder}</TableCell>
                    <TableCell  sx={{color:'#fff',borderLeft:'1px solid #fff'}}>{row.openhoures}</TableCell>
                    <TableCell  sx={{color:'#fff',borderLeft:'1px solid #fff'}}>{row.adress}</TableCell>
                    <TableCell  sx={{color:'#fff',borderLeft:'1px solid #fff',cursor:'pointer'}}>
                        <Link href={`https://superapp.jansnak.com/choose/${row.RealBranch}/${row.WaitTime}/${row.IsClosed}/${row.jantype}`}  target="_blank">
                            ثبت سفارش
                        </Link>
                    </TableCell>
                    <TableCell  sx={{color:'#fff',borderLeft:'1px solid #fff',cursor:'pointer'}} >
                    <Link href='https://superapp.jansnak.com/nearBranch' target="_blank">
                            مکان یابی
                    </Link>

                    </TableCell>
                    <TableCell  sx={{color:'#fff',borderLeft:'1px solid #fff',cursor:'pointer'}}>
                        <Link href={row.tourlink}  target="_blank">
                            تور مجازی
                        </Link>
                    </TableCell>
                </TableRow>
            ))}
            </TableBody>
        </Table>
        </TableContainer>

    </Box>
  )
}

export default Branches